class TicketsApiService {
  constructor(HttpService) {
    'ngInject';

    this.HttpService = HttpService;
  }

  tickets(payload) {
    return this.HttpService.post('/customer/fetch/tickets', payload);
  }

  fetchTickets() {
    return this.HttpService.get('/zendesk/ticket');
  }

  fetchTicketDetails(payload) {
    const queryParams = this.HttpService.buildQueryParamsFromPayload(payload);
    return this.HttpService.get(`/zendesk/ticket-details?${queryParams}`);
  }

  fetchTicketToken() {
    return this.HttpService.get('/zendesk/ticket-token');
  }
}

export default TicketsApiService;



// WEBPACK FOOTER //
// ./client/app/api/services/tickets.api.service.js